import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SidePanelItem from './SidePanelItem.js';

import './SidePanelItems.scss';

class SidePanelItems extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  renderItems() {
    return this.props.items.map(item => (
      <SidePanelItem
        item={item}
        isActive={this.props.activeItemId === item.id}
        onClose={this.props.onClose}
        key={item.id}
      />
    ));
  }

  render() {
    return (
      <div
        className={classNames('SidePanel__items', {
          'SidePanel__items--opened': this.props.opened
        })}
      >
        {this.renderItems()}
      </div>
    );
  }
}

SidePanelItems.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      group: PropTypes.string.isRequired,
      label: PropTypes.string,
      content: PropTypes.node
    })
  ),
  onClose: PropTypes.func.isRequired,
  opened: PropTypes.bool,
  activeItemId: PropTypes.string
};

export default SidePanelItems;
